import { render, staticRenderFns } from "./edit-setting.vue?vue&type=template&id=4fb5c614&scoped=true&"
import script from "./edit-setting.vue?vue&type=script&lang=js&"
export * from "./edit-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb5c614",
  null
  
)

export default component.exports